import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  checkInMember,
  removeMemberCheckIn,
} from "@/api/checkin";

type CheckInVariables = {
  memberId: string;
  checkedIn: boolean;
};

export function useCheckIn(
  churchId: string | null,
  serviceOccurrenceId: string | undefined
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      memberId,
      checkedIn,
    }: CheckInVariables) => {
      if (checkedIn) {
        await checkInMember(
          churchId!,
          serviceOccurrenceId!,
          {
            member_id: memberId,
            status: "PRESENT",
          }
        );

        return;
      }

      await removeMemberCheckIn(
        churchId!,
        serviceOccurrenceId!,
        memberId
      );
    },

    onSuccess: async () => {
      await Promise.all([
        ...["members", "member", "member-attendance-history", "member-attendance-summary", "member-attendance-calendar"]
          .map(key => queryClient.invalidateQueries({ queryKey: [key, churchId] })),
        ...["youth-report", "youth-intelligence", "youth-care"].map(key => queryClient.invalidateQueries({queryKey: [key, churchId]})),
        queryClient.invalidateQueries({ queryKey: ["occurrence-attendance", churchId, serviceOccurrenceId] }),
        queryClient.invalidateQueries({
          queryKey: [
            "attendance-roster",
            churchId,
            serviceOccurrenceId,
          ],
        }),

        queryClient.invalidateQueries({
          queryKey: ["attendance-records", churchId],
        }),

        queryClient.invalidateQueries({
          queryKey: ["dashboard", churchId],
        }),

        queryClient.invalidateQueries({
          queryKey: ["household-intelligence", churchId],
        }),
      ]);
    },
  });
}